import { ref, onMounted, onUnmounted } from 'vue'
export function useChartLabelSize(viewBoxWidth) {
  const chart = ref(null), labelSize = ref('12.5px')
  let observer
  onMounted(() => {
    observer = new ResizeObserver(([entry]) => {
      const size = parseFloat(getComputedStyle(chart.value).getPropertyValue('--fs-12')) || 12.5
      if (entry.contentRect.width > 0) labelSize.value = (size * viewBoxWidth / entry.contentRect.width) + 'px'
    })
    observer.observe(chart.value)
  })
  onUnmounted(() => observer?.disconnect())
  return { chart, labelSize }
}
